import feedbackSubjects from '@/api/feedbackSubjects'

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    SET_ITEMS (state, items) {
      state.items = items || []
    }
  },
  actions: {
    async fetch ({ commit }) {
      const { data: { data } } = await feedbackSubjects.index({
        'page[all]': 1,
        'filter[publish]': 1,
        'sort': 'weight'
      })

      commit('SET_ITEMS', data)
    }
  }
}
